import { FC } from 'react';

import _ from 'lodash';

import { Column, TableBodyProps } from '../../utils/models';
import { renderCell, renderStyle } from '../../utils/utilities';

import css from '../../scss/table.module.scss';
import Conditional from './conditional';
import Skeleton from './skeleton';

interface Props extends TableBodyProps {
	loading: boolean;
}

const TableBody: FC<Props> = (props): JSX.Element => {
	const createKey = (item: any, column: Column): string => {
		return item._id + (column.path || column.key);
	};

	const renderCellProps = (column: Column) => {
		if (column.cellProps) return column.cellProps;

		return {};
	};

	return (
		<tbody>
			<Conditional isVisible={!props.loading}>
				{props.data.map((item, index) => (
					<tr key={index}>
						{props.columns.map((column: Column) => (
							<td
								className={css['table-row']}
								key={createKey(item, column)}
								style={renderStyle(item, column)}
								{...renderCellProps(column)}
							>
								{renderCell(item, column, index)}
							</td>
						))}
					</tr>
				))}
			</Conditional>
			
			<Conditional isVisible={props.loading}>
				{_.range(1, 11).map((item, index) => (
					<tr key={index} style={{ marginBottom: 2}}>
						{props.columns.map((column: Column) => (
							<td key={createKey(item, column)}>
								<Skeleton height="0.5rem" />
							</td>
						))}
					</tr>
				))}
			</Conditional>
		</tbody>
	);
};

export default TableBody;
